import { useQuery } from "@apollo/client";
import { Badge, Thumbnail } from "@shopify/polaris";
import React from "react";
import style from "../../../../scss/module/product_sku.module.scss";
import { SketonProduct } from "./SketonProduct";
import { QUERY_PRODUCT_LIST } from "./LoadProductWithSKU";
import { Graph } from "src/generated/graph";

interface Props {
  productSelected: any[];
  skuId: number[];
  productOnly?: boolean;
  onRemove?: (v: any) => void;
  onRemoveSku?: (v: any, productId: number) => void;
}

export function ProductSelectList({ productOnly, productSelected, skuId, onRemove, onRemoveSku }: Props) {
  const queryProduct = useQuery<Graph.Query>(QUERY_PRODUCT_LIST, {
    skip: productSelected.length === 0,
    variables: {
      productListType: "APPROVED",
      orderBy: {
        field: "ID",
        sortBy: "DESC",
        value: productSelected,
      },
      page: {
        offset: 0,
        limit: productSelected.length,
        cacheTotalRow: undefined,
      },
    },
  });

  if (queryProduct.loading) {
    return (
      <div>
        <SketonProduct rowsCount={skuId.length} />
      </div>
    );
  }

  return (
    <div>
      {queryProduct.data &&
        productSelected
          .map((x, i) => ({ id: x, index: i }))
          .sort((a, b) => b.index - a.index)
          .map((x) => {
            const find = queryProduct.data?.productListV2?.data?.find((f) => Number(f.id) === Number(x.id));
            if (find) {
              return (
                <div key={x.id}>
                  <div className={style.basic_product}>
                    <div className={style.info}>
                      <div className="ml-3">
                        <Thumbnail alt={find.code || ""} source={find.picture || ""} size="small" />
                      </div>
                      <div className="ml-3">
                        <small>{find.supplierCode}</small>
                        <br />
                        <small style={{ fontWeight: "bold" }}>${find.price}</small>
                        <br />
                        <small>L192: {find.code}</small>
                      </div>
                    </div>
                    <div>
                      <div style={{ cursor: "pointer" }} onClick={() => onRemove && onRemove(find.id)}>
                        <Badge tone="critical" size="small">
                          Remove
                        </Badge>
                      </div>
                    </div>
                  </div>
                  {!productOnly &&
                    find.skuList
                      ?.filter((f) => skuId.includes(Number(f.id)))
                      .map((sku) => {
                        return (
                          <div className={style.basic_product} key={x.id + ""}>
                            <div className={style.sku}>
                              <div className="ml-1">
                                <small>{sku.option1 || "No Color"}</small>
                              </div>
                            </div>
                            <div className={style.qty}>
                              <small>{sku.option2 || "No Size"}</small>
                            </div>
                            <div className={style.price}>
                              <small>{sku.stockQty} available</small>
                            </div>
                            <div>
                              <div
                                style={{ cursor: "pointer" }}
                                onClick={() => onRemoveSku && onRemoveSku(sku.id, Number(find.id))}
                              >
                                <Badge tone="critical" size="small">
                                  Remove
                                </Badge>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                </div>
              );
            }
            return <div key={x.id}></div>;
          })}
    </div>
  );
}
